import deepEqual from 'fast-deep-equal'
import { isEmpty } from 'ramda'

import type { Document as DocumentType } from '~/types'

/**
 * Determines if there are unsaved changes.
 *
 * When the input forms feature toggle is off (i.e. isInputFormsEnabled is false),
 * we remove the `documentElements` field from the template before comparing the two document objects.
 *
 * @param documentCandidate - The current (edited) document.
 * @param newDocument - The new document generated (e.g., via getNewDocument).
 * @param isInputFormsEnabled - Feature toggle flag.
 * @returns True if there are unsaved changes; otherwise, false.
 */
export function documentsHasUnsavedChanges(
  documentCandidate: any,
  newDocument: DocumentType,
  isInputFormsEnabled: boolean,
): boolean {
  const documentIsReady =
    Boolean(documentCandidate?.template) && !isEmpty(documentCandidate)

  if (!isInputFormsEnabled) {
    // Create copies so we don't mutate the originals.
    const candidateCopy = {
      ...documentCandidate,
      template: { ...documentCandidate.template },
    }
    const newDocCopy = {
      ...newDocument,
      template: { ...newDocument.template },
    }
    // Remove the documentElements field from both.
    delete candidateCopy.template.documentElements
    delete newDocCopy.template.documentElements

    return documentIsReady && !deepEqual(candidateCopy, newDocCopy)
  }

  return documentIsReady && !deepEqual(documentCandidate, newDocument)
}
